import { createSelector } from 'reselect';

const selectProductTypes = (state: any) => state.productTypes;

export const selectProductTypesCurrentItem = createSelector([selectProductTypes], (productTypes) => productTypes.current);

export const selectProductTypesListItems = createSelector([selectProductTypes], (productTypes) => productTypes.list);

export const selectProductTypesItemById = (itemId: any) =>
    createSelector(selectProductTypesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectProductTypesQueryItems = createSelector([selectProductTypes], (productTypes) => productTypes.query);

export const selectProductTypesCreatedItem = createSelector([selectProductTypes], (productTypes) => productTypes.create);

export const selectProductTypesUpdatedItem = createSelector([selectProductTypes], (productTypes) => productTypes.update);

export const selectProductTypesReadItem = createSelector([selectProductTypes], (productTypes) => productTypes.read);

export const selectProductTypesDeletedItem = createSelector([selectProductTypes], (productTypes) => productTypes.delete);

export const selectProductTypesSearchedItems = createSelector([selectProductTypes], (productTypes) => productTypes.search);

export const selectProductTypesItemsCount = createSelector([selectProductTypes], (productTypes) => productTypes.count);

export const selectProductTypesItemsFilter = createSelector([selectProductTypes], (productTypes) => productTypes.filter);